<template>
  <div>
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        Already have an account?
      </span>
      <router-link
        :to="{ name: 'login' }"
        class="font-weight-bold font-size-3 ml-2"
      >
        Log In!
      </router-link>
    </div>
    <div class="login-form login-signin">
      <div class="text-center mt-15 mb-1 mb-lg-2">
        <h3 class="font-size-h1">Enroll Account</h3>
        <!--        <p class="text-muted font-weight-semi-bold">-->
        <!--          Manually enroll for an Authority to Generate. Note that your e-Receipt-->
        <!--          solutions provider can also apply for an ATG on your behalf.-->
        <!--        </p>-->
      </div>
      <div class="card card-custom">
        <div class="card-body p-0">
          <!--begin: Wizard-->
          <div
            id="kt_wizard_v1"
            class="wizard wizard-1"
            data-wizard-clickable="true"
            data-wizard-state="step-first"
          >
            <!--begin: Wizard Nav-->
            <div class="wizard-nav border-bottom">
              <div class="wizard-steps p-8 p-lg-10">
                <div
                  class="wizard-step"
                  data-wizard-state="current"
                  data-wizard-type="step"
                >
                  <div class="wizard-label">
                    <i class="wizard-icon flaticon-list"></i>
                    <h3 class="wizard-title">1. Business Info</h3>
                  </div>
                  <i class="wizard-arrow flaticon2-next"></i>
                </div>
                <div
                  class="wizard-step"
                  data-wizard-state="current"
                  data-wizard-type="step"
                >
                  <div class="wizard-label">
                    <i class="wizard-icon flaticon-list"></i>
                    <h3 class="wizard-title">2. ATG</h3>
                  </div>
                  <i class="wizard-arrow flaticon2-next"></i>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <i class="wizard-icon flaticon-user-ok"></i>
                    <h3 class="wizard-title">3. Authorized User</h3>
                  </div>
                  <i class="wizard-arrow flaticon2-next"></i>
                </div>
                <div class="wizard-step" data-wizard-type="step">
                  <div class="wizard-label">
                    <i class="wizard-icon flaticon-user-settings"></i>
                    <h3 class="wizard-title">4. Account Info</h3>
                  </div>
                </div>
              </div>
            </div>
            <!--end: Wizard Nav-->

            <!--begin: Wizard Body-->
            <div
              class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10"
            >
              <div class="col-xl-12 col-xxl-11">
                <!--begin: Wizard Form-->
                <b-form id="kt_form" class="form">
                  <!--Business Info-->
                  <div
                    class="pb-5"
                    data-wizard-state="current"
                    data-wizard-type="step-content"
                  >
                    <!--                  <h4 class="mb-10 font-weight-bold text-dark">Business Information</h4>-->
                    <b-form-group label="Taxpayer Classification">
                      <b-form-radio-group
                        v-model="$v.form.classification.$model"
                        :options="options.classifications"
                        :state="validateState('classification')"
                        name="radio-classification"
                      ></b-form-radio-group>
                      <b-form-invalid-feedback>
                        Taxpayer Classification is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <b-form-group label="TIN" label-for="tin">
                          <b-form-input
                            v-model="$v.form.tin.$model"
                            v-mask="'###-###-###'"
                            :state="validateState('tin')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="tin"
                            placeholder="TIN"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            TIN is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6">
                        <b-form-group
                          label="Branch Code"
                          label-for="branchcode"
                        >
                          <b-form-input
                            v-model="$v.form.branchcode.$model"
                            v-mask="'#####'"
                            :state="validateState('branchcode')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="branchcode"
                            placeholder="Branch Code"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Branch Code is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <b-form-group
                          label="Revenue District Office"
                          label-for="rdo"
                        >
                          <b-form-select
                            v-model="$v.form.rdo.$model"
                            :options="options.rdo"
                            :state="validateState('rdo')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="rdo"
                            placeholder="Revenue District Office"
                            size="sm"
                          ></b-form-select>

                          <!--              <b-form-input :state="validateState('rdo')" class="form-control form-control-solid h-auto py-3 px-3" name="rdo" placeholder="Revenue District Office" size="sm" v-model="$v.form.rdo.$model"></b-form-input>-->
                          <b-form-invalid-feedback>
                            Revenue District Office is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6">
                        <b-form-group label="Tax Type">
                          <b-form-radio-group
                            v-model="$v.form.taxtype.$model"
                            :options="options.taxtypes"
                            :state="validateState('taxtype')"
                            name="radio-taxtype"
                          ></b-form-radio-group>
                          <b-form-invalid-feedback>
                            Tax Type is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <b-form-group
                      label="Business Name"
                      label-for="businessname"
                    >
                      <b-form-input
                        v-model="$v.form.businessname.$model"
                        :state="validateState('businessname')"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        name="businessname"
                        placeholder="Business Name"
                        size="sm"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        Business Name is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <div
                      v-if="form.classification === 'individual'"
                      class="row"
                    >
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="First Name"
                          label-for="businessfirstname"
                        >
                          <b-form-input
                            v-model="$v.form.businessfirstname.$model"
                            :state="validateState('businessfirstname')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="businessfirstname"
                            placeholder="First Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            First Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Middle Name"
                          label-for="businessmiddlename"
                        >
                          <b-form-input
                            v-model="$v.form.businessmiddlename.$model"
                            :state="validateState('businessmiddlename')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="businessmiddlename"
                            placeholder="Middle Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Middle Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Last Name"
                          label-for="businesslastname"
                        >
                          <b-form-input
                            v-model="$v.form.businesslastname.$model"
                            :state="validateState('businesslastname')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="businesslastname"
                            placeholder="Last Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Last Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <b-form-group
                      v-if="form.classification === 'non-individual'"
                      label="Registered Name"
                      label-for="registeredname"
                    >
                      <b-form-checkbox
                        id="chkRegisteredName"
                        v-model="form.registerednamesameasbusinessname"
                        name="chkRegisteredName"
                        @change="onChangeSameRegisteredName"
                      >
                        Same as business name
                      </b-form-checkbox>
                      <b-form-input
                        v-model="$v.form.registeredname.$model"
                        :state="validateState('registeredname')"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        name="registeredname"
                        placeholder="Registered Name"
                        size="sm"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        Registered Name is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      :label="($v.form.classification.$model== 'individual')? 'Date of birth' : 'Date of Incorporation'"
                      label-for="dateofincorporation"
                    >
                      <b-input-group>
                        <b-form-input
                          v-model="$v.form.dateofincorporation.$model"
                          :state="validateState('dateofincorporation')"
                          name="dateofincorporation"
                          type="text"
                          autocomplete="off"
                          v-mask="'####-##-##'"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          placeholder="YYYY-MM-DD"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            v-model="$v.form.dateofincorporation.$model"
                            :state="validateState('dateofincorporation')"
                            class="button-only-datepicker"
                            name="dateofincorporation"
                            size="sm"
                            button-only
                            right
                            locale="en-US"
                          ></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback>
                          {{($v.form.classification.$model== 'individual')? 'Date of birth' : 'Date of Incorporation'}} is required.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group
                      label="Line of Business"
                      label-for="lineofbusiness"
                    >
                      <b-form-input
                        v-model="$v.form.lineofbusiness.$model"
                        :state="validateState('lineofbusiness')"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        name="lineofbusiness"
                        placeholder="Line of Business"
                        size="sm"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        Line of Business Office is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      label="Business Address"
                      label-for="businessaddress"
                    >
                      <b-form-input
                        v-model="$v.form.businessaddress.$model"
                        :state="validateState('businessaddress')"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        name="businessaddress"
                        placeholder="Business Address"
                        size="sm"
                      ></b-form-input>
                      <b-form-invalid-feedback>
                        Business Address is required.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <!--ATG-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h3 class="mb-10 font-weight-bold text-dark">
                      ATG
                    </h3>
                    <div class="row">
                      <div class="col-12">
                        <b-form-group label="ATG ID" label-for="atgid">
                          <b-form-input
                            v-model="$v.form.atgid.$model"
                            :state="validateState('atgid')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="ATG ID"
                            placeholder="ATG ID"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            ATG ID is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <b-form-group label="ATG Key" label-for="atgkey">
                          <b-form-input
                            v-model="$v.form.atgkey.$model"
                            :state="validateState('atgkey')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="atgkey"
                            placeholder="ATG Key"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            ATG Key is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="alert alert-danger"
                      v-if="invalidAtgMessage !== ''"
                    >
                      {{ invalidAtgMessage }}
                    </div>
                  </div>
                  <!--Authorized User-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h3 class="mb-10 font-weight-bold text-dark">
                      Authorized User
                    </h3>
                    <div class="row">
                      <div class="col-12 col-md-4">
                        <b-form-group label="First Name" label-for="firstname">
                          <b-form-input
                            v-model="$v.form.firstname.$model"
                            :state="validateState('firstname')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="firstname"
                            placeholder="First Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            First Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Middle Name"
                          label-for="middlename"
                        >
                          <b-form-input
                            v-model="$v.form.middlename.$model"
                            :state="validateState('middlename')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="middlename"
                            placeholder="Middle Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Middle Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group label="Last Name" label-for="lastname">
                          <b-form-input
                            v-model="$v.form.lastname.$model"
                            :state="validateState('lastname')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="lastname"
                            placeholder="Last Name"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Last Name is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Email Address"
                          label-for="emailaddress"
                        >
                          <b-form-input
                            v-model="$v.form.emailaddress.$model"
                            :state="validateState('emailaddress')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="emailaddress"
                            placeholder="Email Address"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Email is required and a valid email address.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Mobile Number"
                          label-for="mobilenumber"
                        >
                          <b-form-input
                            v-model="$v.form.mobilenumber.$model"
                            v-mask="'####-###-####'"
                            :state="validateState('mobilenumber')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="mobilenumber"
                            placeholder="Mobile Number"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Mobile Number is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-group
                          label="Landline (Optional)"
                          label-for="landline"
                        >
                          <b-form-input
                            v-model="$v.form.landline.$model"
                            v-mask="'(##) ####-####'"
                            :state="validateState('landline')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            masked="false"
                            name="landline"
                            placeholder="Landline"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Landline is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <!--Account Info-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <h3 class="mb-10 font-weight-bold text-dark">
                      Account Information
                    </h3>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <b-form-group label="Username" label-for="username">
                          <b-form-input
                            v-model="$v.form.username.$model"
                            :state="validateState('username')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            disabled
                            name="username"
                            placeholder="Username"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Username is required.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <b-form-group label="Password" label-for="password">
                          <b-form-input
                            v-model="$v.form.password.$model"
                            :state="validateState('password')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="password"
                            placeholder="Password"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            At least 8 characters—the more characters, the
                            better<br />
                            A mixture of both uppercase and lowercase letters<br />
                            A mixture of letters and numbers<br />
                            Inclusion of at least one special character, e.g., !
                            @ # ? ]
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6">
                        <b-form-group
                          label="Confirm Password"
                          label-for="passwordconfirm"
                        >
                          <b-form-input
                            v-model="$v.form.passwordconfirm.$model"
                            :state="validateState('passwordconfirm')"
                            class="form-control form-control-solid h-auto py-3 px-3"
                            name="passwordconfirm"
                            placeholder="Confirm Password"
                            size="sm"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            Confirm Password is required and must match the
                            password
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <!--Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                        class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-prev"
                        type="button"
                      >
                        Previous
                      </button>
                    </div>
                    <div>
                      <button
                        ref="submit"
                        :disabled="isBusy"
                        class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-submit"
                        type="button"
                        v-on:click="submit"
                      >
                        Submit
                      </button>
                      <button
                        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-next"
                        type="button"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </b-form>
                <!--end: Wizard Form-->
              </div>
            </div>
            <!--end: Wizard Body-->
          </div>
        </div>
        <!--end: Wizard-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-1.scss";
</style>

<script>
import { mapState } from "vuex";
import { LOGOUT, REGISTERMESSAGE } from "@/core/services/store/auth.module";
import { validationMixin } from "vuelidate";
import {
  email,
  helpers,
  minLength,
  required,
  sameAs
} from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import ApiService from "@/view/pages/easyreceipt/api";

const strongpassword = helpers.regex(
  "strongpassword",
  /^((?=.*\d)(?=.*[A-Z])(?=.*\W).{8,50})$/
);

export default {
  mixins: [validationMixin],
  name: "register",
  directives: { mask },
  data() {
    return {
      isBusy: false,
      invalidAtgMessage: "",
      form: {
        classification: "",
        tin: "",
        branchcode: "",
        rdo: "",
        taxtype: "",
        businessname: "",
        registerednamesameasbusinessname: false,
        registeredname: "",
        businessfirstname: "",
        businessmiddlename: "",
        businesslastname: "",
        dateofincorporation: "",
        lineofbusiness: "",
        businessaddress: "",
        atgid: "",
        atgkey: "",
        firstname: "",
        middlename: "",
        lastname: "",
        emailaddress: "",
        mobilenumber: "",
        landline: "",
        username: "",
        password: "",
        passwordconfirm: ""
      },
      options: {
        classifications: [
          {
            text: "Individual",
            value: "individual"
          },
          {
            text: "Non-Individual",
            value: "non-individual"
          }
        ],
        taxtypes: [
          {
            text: "VAT",
            value: "VAT"
          },
          {
            text: "Non-VAT",
            value: "Non-VAT"
          }
        ],
        rdo: [
          {
            value: "001",
            text: "001 - LAOAG CITY"
          },
          {
            value: "002",
            text: "002 - VIGAN, ILOCOS SUR"
          },
          {
            value: "003",
            text: "003 - SAN FERNANDO, LA UNION"
          },
          {
            value: "004",
            text: "004 - CALASIAO, WEST PANGASINAN"
          },
          {
            value: "005",
            text: "005 - ALAMINOS, WEST PANGASINAN"
          },
          {
            value: "006",
            text: "006 - URDANETA, EAST PANGASINAN"
          },
          {
            value: "007",
            text: "007 - BANGUED, ABRA"
          },
          {
            value: "008",
            text: "008 - BAGUIO CITY"
          },
          {
            value: "009",
            text: "009 - LA TRINIDAD, BENGUET"
          },
          {
            value: "010",
            text: "010 - BONTOC, MT. PROVINCE"
          },
          {
            value: "011",
            text: "011 - TABUK, KALINGA APAYAO"
          },
          {
            value: "012",
            text: "012 - LAGAWE, IFUGAO"
          },
          {
            value: "013",
            text: "013 - TUGUEGARAO, CAGAYAN"
          },
          {
            value: "014",
            text: "014 - BAYOMBONG, NUEVA VIZCAYA"
          },
          {
            value: "015",
            text: "015 - NAGUILIAN, ISABELA"
          },
          {
            value: "016",
            text: "016 - CABARROGUIS, QUIRINO"
          },
          {
            value: "17A",
            text: "17A - TARLAC CITY"
          },
          {
            value: "17B",
            text: "17B - PANIQUI, TARLAC"
          },
          {
            value: "018",
            text: "018 - OLONGAPO"
          },
          {
            value: "019",
            text: "019 - SUBIC"
          },
          {
            value: "020",
            text: "020 - BALANGA, BATAAN"
          },
          {
            value: "21A",
            text: "21A - NORTH PAMPANGA"
          },
          {
            value: "21B",
            text: "21B - SOUTH PAMPANGA"
          },
          {
            value: "21C",
            text: "21C - CLARK FREEPORT ZONE"
          },
          {
            value: "022",
            text: "022 - BALER, AURORA"
          },
          {
            value: "23A",
            text: "23A - NORTH NUEVA ECIJA"
          },
          {
            value: "23B",
            text: "23B - SOUTH NUEVA ECIJA"
          },
          {
            value: "024",
            text: "024 - VALENZUELA"
          },
          {
            value: "25A",
            text: "25A - PLARIDEL, BULACAN"
          },
          {
            value: "25B",
            text: "25B - STA. MARIA, BULACAN"
          },
          {
            value: "026",
            text: "026 - MALABON - NAVOTAS"
          },
          {
            value: "027",
            text: "027 - KALOOKAN CITY"
          },
          {
            value: "028",
            text: "028 - NOVALICHES"
          },
          {
            value: "029",
            text: "029 - SAN NICOLAS, TONDO"
          },
          {
            value: "030",
            text: "030 - BINONDO"
          },
          {
            value: "031",
            text: "031 - STA. CRUZ"
          },
          {
            value: "032",
            text: "032 - QUIAPO-SAMPALOC-SAN MIGUEL"
          },
          {
            value: "033",
            text: "033 - INTRAMUROS-ERMITA-MALATE"
          },
          {
            value: "034",
            text: "034 - PACO-PANDACAN-STA. ANA"
          },
          {
            value: "035",
            text: "035 - ROMBLON"
          },
          {
            value: "036",
            text: "036 - PUERTO PRINCESA"
          },
          {
            value: "037",
            text: "037 - SAN JOSE, OCCIDENTAL MINDORO"
          },
          {
            value: "038",
            text: "038 - NORTH-QUEZON CITY"
          },
          {
            value: "039",
            text: "039 - SOUTH-QUEZON CITY"
          },
          {
            value: "040",
            text: "040 - CUBAO"
          },
          {
            value: "041",
            text: "041 - MANDALUYONG"
          },
          {
            value: "042",
            text: "042 - SAN JUAN"
          },
          {
            value: "043",
            text: "043 - PASIG CITY"
          },
          {
            value: "044",
            text: "044 - TAGUIG-PATEROS"
          },
          {
            value: "045",
            text: "045 - MARIKINA"
          },
          {
            value: "046",
            text: "046 - CAINTA-TAYTAY"
          },
          {
            value: "047",
            text: "047 - EAST MAKATI "
          },
          {
            value: "048",
            text: "048 - WEST MAKATI"
          },
          {
            value: "049",
            text: "049 - NORTH-MAKATI"
          },
          {
            value: "050",
            text: "050 - SOUTH-MAKATI"
          },
          {
            value: "051",
            text: "051 - PASAY"
          },
          {
            value: "052",
            text: "052 - PARAÑAQUE"
          },
          {
            value: "53A",
            text: "53A - LAS PIÑAS CITY"
          },
          {
            value: "53B",
            text: "53B - MUNTINLUPA CITY"
          },
          {
            value: "54A",
            text: "54A - EAST CAVITE"
          },
          {
            value: "54B",
            text: "54B - WEST CAVITE"
          },
          {
            value: "055",
            text: "055 - EAST LAGUNA"
          },
          {
            value: "056",
            text: "056 - CENTRAL LAGUNA"
          },
          {
            value: "057",
            text: "057 - WEST LAGUNA"
          },
          {
            value: "058",
            text: "058 - BATANGAS CITY"
          },
          {
            value: "059",
            text: "059 - EAST BATANGAS"
          },
          {
            value: "060",
            text: "060 - NORTH QUEZON"
          },
          {
            value: "061",
            text: "061 - SOUTH QUEZON"
          },
          {
            value: "062",
            text: "062 - MARINDUQUE"
          },
          {
            value: "063",
            text: "063 - CALAPAN, ORIENTAL MINDORO"
          },
          {
            value: "064",
            text: "064 - DAET, CAMARINES NORTE"
          },
          {
            value: "065",
            text: "065 - NAGA CITY"
          },
          {
            value: "066",
            text: "066 - IRIGA CITY"
          },
          {
            value: "067",
            text: "067 - LEGASPI CITY"
          },
          {
            value: "068",
            text: "068 - SORSOGON, SORSOGON"
          },
          {
            value: "069",
            text: "069 - VIRAC, CATANDUANES"
          },
          {
            value: "070",
            text: "070 - MASBATE, MASBATE"
          },
          {
            value: "071",
            text: "071 - KALIBO, AKLAN"
          },
          {
            value: "072",
            text: "072 - ROXAS CITY"
          },
          {
            value: "073",
            text: "073 - SAN JOSE, ANTIQUE"
          },
          {
            value: "074",
            text: "074 - ILOILO CITY"
          },
          {
            value: "075",
            text: "075 - ZARRRAGA, ILOILO"
          },
          {
            value: "076",
            text: "076 - VICTORIAS, NEGROS OCCIDENTAL"
          },
          {
            value: "077",
            text: "077 - BACOLOD CITY"
          },
          {
            value: "078",
            text: "078 - BINALBAGAN, NEGROS OCCIDENTAL"
          },
          {
            value: "079",
            text: "079 - DUMAGUETE CITY"
          },
          {
            value: "080",
            text: "080 - MANDAUE CITY"
          },
          {
            value: "081",
            text: "081 - CEBU CITY, NORTH"
          },
          {
            value: "082",
            text: "082 - CEBU CITY, SOUTH"
          },
          {
            value: "083",
            text: "083 - TALISAY, CEBU"
          },
          {
            value: "084",
            text: "084 - TAGBILARAN CITY"
          },
          {
            value: "085",
            text: "085 - CATARMAN, NORTHERN SAMAR"
          },
          {
            value: "086",
            text: "086 - BORONGAN, EASTERN SAMAR"
          },
          {
            value: "087",
            text: "087 - CATBALOGAN, WESTERN SAMAR"
          },
          {
            value: "088",
            text: "088 - TACLOBAN CITY"
          },
          {
            value: "089",
            text: "089 - ORMOC CITY"
          },
          {
            value: "090",
            text: "090 - MAASIN, SOUTHERN LEYTE"
          },
          {
            value: "091",
            text: "091 - DIPOLOG CITY"
          },
          {
            value: "092",
            text: "092 - PAGADIAN CITY"
          },
          {
            value: "93A",
            text: "93A - ZAMBOANGA CITY"
          },
          {
            value: "93B",
            text: "93B - ZAMBOANGA SIBUGAY"
          },
          {
            value: "094",
            text: "094 - ISABELA, BASILAN"
          },
          {
            value: "095",
            text: "095 - JOLO, SULU"
          },
          {
            value: "096",
            text: "096 - BONGAO, TAWI-TAWI"
          },
          {
            value: "097",
            text: "097 - GINGOOG CITY"
          },
          {
            value: "098",
            text: "098 - CAGAYAN DE ORO CITY"
          },
          {
            value: "099",
            text: "099 - MALAYBALAY, BUKIDNON"
          },
          {
            value: "100",
            text: "100 - OZAMIS CITY"
          },
          {
            value: "101",
            text: "101 - ILIGAN CITY"
          },
          {
            value: "102",
            text: "102 - MARAWI CITY"
          },
          {
            value: "103",
            text: "103 - BUTUAN CITY"
          },
          {
            value: "104",
            text: "104 - BAYUGAN, AGUSAN DEL SUR"
          },
          {
            value: "105",
            text: "105 - SURIGAO CITY"
          },
          {
            value: "106",
            text: "106 - TANDAG, SURIGAO DEL SUR"
          },
          {
            value: "107",
            text: "107 - COTABATO CITY"
          },
          {
            value: "108",
            text: "108 - KIDAPAWAN, NORTH COTABATO"
          },
          {
            value: "109",
            text: "109 - TACURONG, SULTAN KUDARAT"
          },
          {
            value: "110",
            text: "110 - GENERAL SANTOS CITY"
          },
          {
            value: "111",
            text: "111 - KORONADAL, SOUTH COTABATO"
          },
          {
            value: "112",
            text: "112 - TAGUM, DAVAO DEL NORTE"
          },
          {
            value: "113",
            text: "113 - WEST DAVAO CITY"
          },
          {
            value: "132",
            text: "132 - EAST DAVAO CITY"
          },
          {
            value: "114",
            text: "114 - MATI, DAVAO ORIENTAL"
          },
          {
            value: "115",
            text: "115 - DIGOS, DAVAO DEL SUR"
          },
          {
            value: "116",
            text: "116 - LTD 116"
          },
          {
            value: "124",
            text: "124 - LTD 124"
          },
          {
            value: "126",
            text: "126 - LTD 126"
          },
          {
            value: "121",
            text: "121 - LTD 121"
          },
          {
            value: "123",
            text: "123 - LTD 123"
          },
          {
            value: "127",
            text: "127 - LTD 127"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      classification: { required },
      tin: { required },
      branchcode: { required },
      rdo: { required },
      taxtype: { required },
      businessname: { required },
      registeredname: { required },
      businessfirstname: { required },
      businessmiddlename: { required },
      businesslastname: { required },
      dateofincorporation: { required },
      lineofbusiness: { required },
      businessaddress: { required },
      atgid: { },
      atgkey: { },
      firstname: { required },
      middlename: { required },
      lastname: { required },
      emailaddress: {
        required,
        email
      },
      mobilenumber: { required },
      landline: {},
      username: {
        required
      },
      password: {
        required,
        strongpassword,
        minLength: minLength(6)
      },
      passwordconfirm: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState({
      error: state => state.auth.errors
    }),
    emailaddress() {
      return this.form.emailaddress;
    },
    bfirstname() {
      return this.form.businessfirstname;
    },
    bmiddlename() {
      return this.form.businessmiddlename;
    },
    blastname() {
      return this.form.businesslastname;
    }
  },
  watch: {
    error() {
      // console.log("WATCH.error:", newValue, oldValue);
      this.isBusy = false;
    },
    emailaddress() {
      this.form.username = this.form.emailaddress;
    },
    bfirstname() {
      this.form.firstname = this.form.businessfirstname;
    },
    bmiddlename() {
      this.form.middlename = this.form.businessmiddlename;
    },
    blastname() {
      this.form.lastname = this.form.businesslastname;
    }
  },
  methods: {
    init() {
      this.initWizard();
      this.resetForm();
    },
    initWizard() {
      let self = this;
      // Initialize form wizard
      const wizard = new KTWizard("kt_wizard_v1", {
        startStep: 1,
        clickableSteps: true
      });

      // Validation before going to next page
      wizard.on("beforeNext", function(wizardObj) {
        if (wizardObj.currentStep === 1 && !self.validateBusinessInfo()) {
          wizardObj.stop();
          return;
        }
        if (wizardObj.currentStep === 2) {
          if(self.form.atgid != '' || self.form.atgkey != '') {
            if (self.validateATG()) {
              wizardObj.stop();
              self.getValidateATG(wizardObj);
            } else {
              wizardObj.stop();
            }
          } else {
            wizardObj.goNext();
          }
          return;
        }
        if (wizardObj.currentStep === 3 && !self.validateAuthorizedUser()) {
          wizardObj.stop();
          return;
        }
        if (wizardObj.currentStep === 4 && !self.validateAccountInfo()) {
          wizardObj.stop();
          return;
        }
      });

      // wizard.on("afterNext", function(wizardObj) {
      //   // validate the form and use below function to stop the wizard's step
      //   // wizardObj.stop();
      //   console.log("afterNext:", wizardObj);
      // });

      // Change event
      wizard.on("change", function(/*wizardObj*/) {
        //console.log("change:", wizardObj);
        setTimeout(() => {
          KTUtil.scrollTop();
        }, 500);
      });
    },
    validateState(name) {
      //console.log(name, this.$v.form[name]);
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        classification: "",
        tin: "",
        branchcode: "",
        rdo: "",
        taxtype: "",
        businessname: "",
        redisterednamesameasbusinessname: false,
        registeredname: "",
        dateofincorporation: "",
        businessfirstname: "",
        businessmiddlename: "",
        businesslastname: "",
        lineofbusiness: "",
        businessaddress: "",
        atgid: "",
        atgkey: "",
        firstname: "",
        middlename: "",
        lastname: "",
        emailaddress: "",
        mobilenumber: "",
        landline: "",
        username: "",
        password: "",
        passwordconfirm: ""
      };
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    validateBusinessInfo: function() {
      let retVal = false;
      retVal =
        this.validateState("classification") &&
        this.validateState("tin") &&
        this.validateState("branchcode") &&
        this.validateState("rdo") &&
        this.validateState("businessname") &&
        this.validateState("dateofincorporation") &&
        this.validateState("lineofbusiness") &&
        this.validateState("businessaddress");

      if (this.form.classification === "individual")
        retVal =
          retVal &&
          this.validateState("businessfirstname") &&
          this.validateState("businessmiddlename") &&
          this.validateState("businesslastname");
      else retVal = retVal && this.validateState("registeredname");

      return retVal;
    },
    validateATG: function() {
      let retVal = false;
      retVal = this.validateState("atgid") && this.validateState("atgkey");
      return retVal;
    },
    validateAuthorizedUser: function() {
      let retVal = false;
      retVal =
        this.validateState("firstname") &&
        this.validateState("middlename") &&
        this.validateState("lastname") &&
        this.validateState("emailaddress") &&
        this.validateState("mobilenumber");
      return retVal;
    },
    validateAccountInfo: function() {
      let retVal = false;
      retVal =
        this.validateState("username") &&
        this.validateState("password") &&
        this.validateState("passwordconfirm");
      return retVal;
    },
    onChangeSameRegisteredName(checked) {
      this.form.registeredname = checked ? this.form.businessname : "";
    },
    submit: function(e) {
      e.preventDefault();
      this.postRegister();
    },
    getValidateATG(wizardObj) {
      let self = this;
      self.isBusy = true;
      self.invalidAtgMessage = "";
      let param = {
        atgid: self.$v.form.atgid.$model,
        atgkey: self.$v.form.atgkey.$model
      };
      ApiService.get("business/validateatg", param)
        .then(({ data }) => {
          this.$gtag.event("register_validateatg", param);
          if (data) {
            self.isBusy = false;
            wizardObj.goNext();
          }
        })
        .catch(error => {
          self.isBusy = false;

          let message = error;
          if (error.response) {
            message =
              error.response.data.error_description ||
              error.response.data.error ||
              error.response.data.message ||
              error.response.data.Message ||
              error.response.statusText;
            if (error.response.data.modelState) {
              for (const [key, value] of Object.entries(
                error.response.data.modelState
              )) {
                if (key) message += key;
                if (value && Array.isArray(value)) {
                  value.forEach(element => (message += "\n" + element));
                }
              }
            }
          }
          self.invalidAtgMessage = message;
        });
    },
    postRegister() {
      let self = this;
      self.isBusy = true;
      this.$store.dispatch(LOGOUT);
      let param = {
        classification: self.$v.form.classification.$model,
        tin: self.$v.form.tin.$model,
        branchcode: self.$v.form.branchcode.$model,
        rdo: self.$v.form.rdo.$model,
        taxtype: self.$v.form.taxtype.$model,
        businessname: self.$v.form.businessname.$model,
        registeredname: self.$v.form.registeredname.$model,
        dateofincorporation: self.$v.form.dateofincorporation.$model,
        businessfirstname: self.$v.form.businessfirstname.$model,
        businessmiddlename: self.$v.form.businessmiddlename.$model,
        businesslastname: self.$v.form.businesslastname.$model,
        lineofbusiness: self.$v.form.lineofbusiness.$model,
        businessaddress: self.$v.form.businessaddress.$model,
        atgid: self.$v.form.atgid.$model,
        atgkey: self.$v.form.atgkey.$model,
        firstname: self.$v.form.firstname.$model,
        middlename: self.$v.form.middlename.$model,
        lastname: self.$v.form.lastname.$model,
        emailaddress: self.$v.form.emailaddress.$model,
        mobilenumber: self.$v.form.mobilenumber.$model,
        landline: self.$v.form.landline.$model,
        username: self.$v.form.username.$model,
        password: self.$v.form.password.$model,
        passwordconfirm: self.$v.form.passwordconfirm.$model
      };
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.post("business/register", param)
        .then(({ data }) => {
          this.$gtag.event("register", param);
          if (data) {
            self.isBusy = false;
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            this.$store
              .dispatch(
                REGISTERMESSAGE,
                "Your account was successfully created."
              )
              .then(() => this.$router.push({ name: "login" }));
          }
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    }
  }
};
</script>
